import styled, { css } from 'styled-components';
import { Button } from '@perch-labs/shrike';
import { Document, Page } from 'react-pdf';
import { zIndexScrollableTermsButton } from 'domain/style';

const borderRadius = css`
  border-radius: 0;
  border-top-left-radius: ${props => props.theme.borderRadii.large};
  border-top-right-radius: ${props => props.theme.borderRadii.large};
`;

export const Wrapper = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-top: none;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;

  ${borderRadius}
`;

export const StyledDocument = styled(Document)`
  width: 0;
`;

const scrollButtonAttrs = () => ({ fullWidth: true });
export const ScrollButton = styled(Button).attrs(scrollButtonAttrs)`
  position: sticky;
  top: 0;
  z-index: ${zIndexScrollableTermsButton};

  ${borderRadius};
`;

export const StyledPage = styled(Page)`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
